import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation(); 

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div>
 
      <nav className="bg-gradient-to-br from-castle-cream-300 to-royal-gold-200 shadow-md p-2 fixed w-full top-0 z-40">
        <div className="container mx-auto flex justify-between items-center">
       
          <span className="font-cursive font-extrabold text-xl text-royal-gold-700">B@B</span>

         
          <div className="hidden md:flex items-center justify-center flex-grow">
            <div className="flex font-medium space-x-6">
              <a href="#hero" className="text-beast-brown-600 px-4 py-2 rounded-lg hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md">
                {t('navbar.home')}
              </a>
              <a href="#intro" className="text-beast-brown-600 px-4 py-2 rounded-lg hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md">
                {t('navbar.intro')}
              </a>
              <a href="#form" className="text-beast-brown-600 px-4 py-2 rounded-lg hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md">
                {t('navbar.form')}
              </a>
              <a href="#details" className="text-beast-brown-600 px-4 py-2 rounded-lg hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md">
                {t('navbar.details')}
              </a>
              <a href="#contact" className="text-beast-brown-600 px-4 py-2 rounded-lg hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md">
                {t('navbar.contact')}
              </a>
            </div>
          </div>

          
          <div className="hidden md:block">
            <LanguageSwitcher />
          </div>

          
          <div className="flex items-center md:hidden">
            <LanguageSwitcher />
            <button
              onClick={toggleMenu}
              className="text-beast-brown-600 p-2 rounded-lg  active:scale-95 transition-transform duration-100"
              aria-label={menuOpen ? t('navbar.closeMenu') : t('navbar.openMenu')}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {menuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
      </nav>

      
      <div
        className={`fixed top-0 left-0 h-full w-2/4 bg-gradient-to-tl from-castle-cream-300 to-royal-gold-200 text-beast-brown-600 shadow-lg transform ${
          menuOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform duration-300 ease-in-out z-40`}
      >
        <div className="p-4">
          <ul className="space-y-4">
            <li>
              <a href="#hero" onClick={toggleMenu} className="block px-4 py-3 rounded-lg hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md transform hover:-translate-x-1">
                {t('navbar.home')}
              </a>
            </li>
            <li>
              <a href="#intro" onClick={toggleMenu} className="block px-4 py-3 rounded-lg hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md transform hover:-translate-x-1">
                {t('navbar.intro')}
              </a>
            </li>
            <li>
              <a href="#form" onClick={toggleMenu} className="block px-4 py-3 rounded-lg hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md transform hover:-translate-x-1">
                {t('navbar.form')}
              </a>
            </li>
            <li>
              <a href="#details" onClick={toggleMenu} className="block px-4 py-3 rounded-lg hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md transform hover:-translate-x-1">
                {t('navbar.details')}
              </a>
            </li>
            <li>
              <a href="#contact" onClick={toggleMenu} className="block px-4 py-3 rounded-lg hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md transform hover:-translate-x-1">
                {t('navbar.contact')}
              </a>
            </li>
          </ul>
        </div>
      </div>

      
      {menuOpen && (
        <div
          onClick={toggleMenu}
          className="fixed inset-0 bg-black bg-opacity-30 z-30"
        ></div>
      )}
    </div>
  );
};

export default Navbar;
